import React, { useContext, useState, useEffect } from "react";
import { Label, Text } from "@fluentui/react";
import { DetailsList, SelectionMode } from "@fluentui/react";
import { SLCreateSLBatchContext } from "../../contexts/SLCreateSLBatchContext";
import { SLLoadingStatus } from "../../utilities/utilities";
import LoadingSpinner from "../../baseComponents/LoadingSpinner";
import { ISLEntryResponse, IAuditInfo } from "./SLCreateSchemas";

function InlineModifiedDateComponent(item: { modifiedOn: any }) {
  const modifiedOnDate = new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "long",
    day: "2-digit",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    hour12: false
  })
    .format(new Date(item.modifiedOn))
    .replace(/,/g, "");
  return <span>{modifiedOnDate}</span>;
}

const columns = [
  {
    key: "col1",
    name: "Modified On",
    fieldName: "modifiedOn",
    minWidth: 50,
    maxWidth: 100,
    isResizable: true,
    onRender: (item: { modifiedOn: any }) => InlineModifiedDateComponent(item)
  },
  {
    key: "col2",
    name: "Action",
    fieldName: "actionName",
    minWidth: 50,
    maxWidth: 100,
    isResizable: true
  },
  {
    key: "col3",
    name: "Alias",
    fieldName: "actionBy",
    minWidth: 50,
    maxWidth: 100,
    isResizable: true
  },
  {
    key: "col4",
    name: "Full Name",
    fieldName: "actionByFullName",
    minWidth: 50,
    maxWidth: 100,
    isResizable: true
  }
];

const SLCreateAuditInfo: React.FC = () => {
  const slCreateContext = useContext(SLCreateSLBatchContext);
  const [auditInfo, setAuditInfo] = useState<IAuditInfo[]>([]);
  const [loadingStatus, setLoadingStatus] = useState<SLLoadingStatus>(SLLoadingStatus.Idle);

  useEffect(() => {
    if (slCreateContext.loadingStatus === SLLoadingStatus.Resolved) {
      if (slCreateContext.entry) {
        const audits = (slCreateContext.entry as ISLEntryResponse).auditInfo;
        setAuditInfo(audits);
      } else {
        setAuditInfo([]);
      }
      setLoadingStatus(SLLoadingStatus.Resolved);
    } else if (slCreateContext.loadingStatus === SLLoadingStatus.Rejected) {
      setLoadingStatus(SLLoadingStatus.Rejected);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slCreateContext.loadingStatus, slCreateContext.entry]);

  if (loadingStatus === SLLoadingStatus.Idle) {
    return null;
  } else if (loadingStatus === SLLoadingStatus.Rejected) {
    return (
      <Text
        variant="xLarge"
        style={{
          color: "var(--accent-font-color, #727272)",
          textAlign: "center"
        }}
      >
        Error while loading Audit Info.
      </Text>
    );
  } else if (slCreateContext.loadingStatus === SLLoadingStatus.Pending) {
    return <LoadingSpinner label="Loading Audit Info" />;
  }
  return (
    <React.Fragment>
      <Label>Audit Details</Label>
      <DetailsList
        compact={true}
        items={auditInfo}
        columns={columns}
        selectionMode={SelectionMode.none}
        ariaLabel={"Audit Info Grid"}
        ariaLabelForGrid={"Table for displaying audit information."}
      />
    </React.Fragment>
  );
};

SLCreateAuditInfo.displayName = "SLCreateAuditInfo";

export default SLCreateAuditInfo;
